import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "dialog-footer"
};
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import api from "@/api/task";
import { ElMessage } from "element-plus";
export default {
  __name: 'dialog',
  emits: ["loadList"],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const {
      t
    } = useI18n();
    const emits = __emit;
    const params = ref({
      id: "",
      notes: "",
      status: ""
    });
    const dialogFormVisible = ref(false);
    const statusOpitons = ref([{
      label: t("task.list.status_map.1"),
      value: 1
    }, {
      label: t("task.list.status_map.2"),
      value: 2
    }, {
      label: t("task.list.status_map.3"),
      value: 3
    }, {
      label: t("task.list.status_map.4"),
      value: 4
    }, {
      label: t("task.list.status_map.5"),
      value: 5
    }]);
    const open = val => {
      console.log(val);
      dialogFormVisible.value = true;
      params.value.id = val.id || "";
      params.value.notes = val.notes || "";
      params.value.status = val.status || "";
    };
    const handleClick = async () => {
      const {
        data
      } = await api.editStatus(params.value);
      if (data.code === 0) {
        ElMessage.success(t("action.success"));
        dialogFormVisible.value = false;
        emits("loadList", "query");
      }
    };
    __expose({
      open
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        class: "status-dia",
        title: _ctx.$t('task.list.editStatus'),
        modelValue: dialogFormVisible.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => dialogFormVisible.value = $event)
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = $event => dialogFormVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleClick
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("action.confirmBtn")), 1)]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: params.value
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: _ctx.$t('task.list.notes')
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: params.value.notes,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => params.value.notes = $event),
              clearable: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_form_item, {
            label: _ctx.$t('task.list.status')
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: params.value.status,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => params.value.status = $event),
              style: {
                "width": "200px"
              }
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statusOpitons.value, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.value,
                  value: item.value,
                  label: item.label
                }, null, 8, ["value", "label"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }, 8, ["label"])]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["title", "modelValue"]);
    };
  }
};